/** vendor */
import { useNavigate } from 'react-router-dom'
import { ExclamationCircleIcon } from '@heroicons/react/outline'

/** lib */
import { IMG_URL, PLACEHOLDER_IMG } from '../../constants/ApiConfiguration'

/** components */
import SaveRecipeForm from '../Forms/SaveRecipeForm'
import TagIcons from '../UI/TagIcons'

export default function RecipeListItem({
    recipe,
    handleOnOpenAllergenDialog = (allergens) => {}
}) {
    const navigate = useNavigate()

    const handleClick = (recipe_id) => {
        if(recipe?.user_recipe_id) {
            navigate(`/community-recipes/${recipe_id}`)
        } else {
            navigate(`/recipes/${recipe_id}`)
        }
    }

    const referenceIngredients = recipe?.recipe_ingredients ?? recipe.reference_ingredients

    const allergens = referenceIngredients.filter((i) => {
        const prop = i?.allergen ?? i?.ingredient
        return (prop)
    })

    const vegan = referenceIngredients.find((i) => {
        const prop = i?.ingredient ?? i
        return (!prop.vegan)
    }) === undefined

    const vegetarian = referenceIngredients.find((i) => {
        const prop = i?.ingredient ?? i
        return (!prop.vegetarian)
    }) === undefined    

    const sugarFree = referenceIngredients.find((i) => {
        const prop = i?.ingredient ?? i
        return (!prop.sugar_free)
    }) === undefined

    const glutenFree = referenceIngredients.find((i) => {
        const prop = i?.ingredient ?? i
        return (!prop.gluten_free)
    }) === undefined

    const dairyFree = referenceIngredients.find((i) => {
        const prop = i?.ingredient ?? i
        return (!prop.dairy_free)
    }) === undefined

    const recipeImage = (recipe?.image) ? `${IMG_URL}/${recipe.image}` : PLACEHOLDER_IMG

    return (
        <div className="w-full p-1 relative">
            <div 
                className="flex cursor-pointer" 
                onClick={() => { 
                    handleClick(recipe?.recipe_id ?? recipe?.value ?? recipe?.user_recipe_id) 
                }}
            >
                <div className="flex-shrink-0">
                    <small className="text-left text-an_green block text-[10px]">
                        {recipe.category?.name}
                    </small> 

                    {
                        recipeImage && 
                            <div className="my-1">
                                <img src={recipeImage} className="w-14 md:w-40 rounded border border-an_green-dark"/>
                            </div>
                    }

                    <small className="text-left text-an_green-dark block text-[10px]">
                        Serves: {recipe.serves}
                    </small>
                    <SaveRecipeForm recipe_id={recipe.recipe_id} />
                </div>

                <div className="flex-grow flex flex-col pl-4">
                    <div className="pb-10 pt-4">          
                        <div className="text-an_green-dark text-xl">
                            { recipe.name }
                        </div>
                        <div className="text-left flex-wrap flex-shrink-1 py-1 text-an_green-dark">
                            {recipe.description}
                        </div>  
                    </div>

                    <div className="absolute bottom-2 right-0 flex w-full justify-end items-center">
                        <div>
                            <TagIcons
                                    fodMapWarning={false}
                                    allergenWarning={allergens.length > 0}
                                    allergenDialog={
                                        (e) => { 
                                            e.stopPropagation()
                                            handleOnOpenAllergenDialog(allergens)
                                        }
                                    }
                                    vegetarian={vegetarian}
                                    vegan={vegan}
                                    glutenFree={glutenFree}
                                    sugarFree={sugarFree}
                                    dairyFree={dairyFree}
                            />           
                        </div>                        
                    </div>

                </div>
            </div>
        </div>
    )
}